import { ActivityCategoryType } from '@surecompanies/activity-log'
import { PaginationFilters } from './pagination'

// Type definition for activity log query parameters
// TODO: used shared DTO if there is package available
export interface ActivityQueriesFilter extends PaginationFilters {
  search?: string
  dateFrom?: string
  dateTo?: string
  clientIds?: string[]
  actorIds?: string[]
  targetIds?: string[]
  applicationId?: string
  categories?: ActivityCategoryType[]
  excludeActions?: string[]
  action?: string[]
}

export enum ActivityReasonCategory {
  QLE = 'QLE',
  ER_REQUEST = 'ER request',
  EE_REQUEST = 'EE request',
  CLEANUP = 'Cleanup',
  OTHER = 'Other',
}

// Actor or Target type
export enum ActivityUserType {
  USER = 'USER',
  COMPANY = 'COMPANY',
  SYSTEM = 'SYSTEM',
}

export interface ActivityAdditionalData extends Record<string, unknown> {
  reason?: string
  reasonCategory?: ActivityReasonCategory
  zendeskTicket?: string
  newData?: Record<string, unknown>
  oldData?: Record<string, unknown>
}

// API Activity types (from activity log API)
export interface ApiActivity {
  id: number
  action: string
  actorClientPublicKey: string
  actorId: string
  actorName: string
  actorRole: string
  actorType: string
  additionalData: ActivityAdditionalData
  category: ActivityCategoryType
  createdOn: string
  description: string
  session: string | null
  source: string
  targetClientPublicKey: string | null
  targetId: string
  targetName: string
  targetRole: string | null
  targetType: string
  timestamp: string
  updatedOn: string
}

// API response type
export interface PaginatedActivity {
  data: ApiActivity[]
  pagination?: {
    currentPage: number
    totalPages: number
    totalItems: number
    hasMore: boolean
  }
}
